import { render, staticRenderFns } from "./corpDialog.vue?vue&type=template&id=acf07e5c&scoped=true"
import script from "./corpDialog.vue?vue&type=script&lang=js"
export * from "./corpDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf07e5c",
  null
  
)

export default component.exports